import { render } from "./LoadoutCard.vue?vue&type=template&id=00bc742b"
import script from "./LoadoutCard.vue?vue&type=script&lang=js"
export * from "./LoadoutCard.vue?vue&type=script&lang=js"

import "./LoadoutCard.vue?vue&type=style&index=0&id=00bc742b&lang=scss"

import exportComponent from "/home/runner/work/MMXD_CardOptimizer/MMXD_CardOptimizer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__